import { supabaseClient } from "@/lib/supabase";
import { useMutation, useQueryClient } from "@tanstack/react-query";

interface DeleteOrganisationLogoParams {
	organisationId: string;
	logo_storage_path: string;
}

async function deleteOrganisationLogo({
	organisationId,
	logo_storage_path,
}: DeleteOrganisationLogoParams): Promise<void> {
	// Delete from storage
	const { error: storageError } = await supabaseClient.storage
		.from("organisation-logos")
		.remove([logo_storage_path]);

	if (storageError) throw storageError;

	// Update organisation to remove logo path
	const { error: updateError } = await supabaseClient
		.from("organisations")
		.update({ logo_storage_path: null })
		.eq("organisation_id", organisationId);

	if (updateError) throw updateError;
}

export function useDeleteOrganisationLogo() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: deleteOrganisationLogo,
		onSuccess: () => {
			// Invalidate and refetch organisations query
			queryClient.invalidateQueries({ queryKey: ["organisations"] });
		},
	});
}
